"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Alert_1 = __importDefault(require("@mui/material/Alert"));
var A_Button = __importStar(require("./A_Button"));
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Snackbar_1 = __importDefault(require("@mui/material/Snackbar"));
var material_1 = require("@mui/material");
// reposition the snackbar default class so it doesn't lie over the AppBar
var StyledSnackbar = (0, material_1.styled)(Snackbar_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        '&.MuiSnackbar-anchorOriginTopCenter': {
            top: '0px',
            padding: '24px',
            position: 'absolute',
            width: '100%',
            zIndex: theme.zIndex.modal,
            boxSizing: 'border-box',
        },
    });
});
/**
 * Figma design node:
 * https://www.figma.com/file/va7snk88pL7TR7F75h7zbt/Design-Files?node-id=9821%3A72247
 */
var Component = function (p) {
    return (Preact.h(StyledSnackbar, { key: p.body, open: p.show, onClose: p.close, ClickAwayListenerProps: { mouseEvent: false }, autoHideDuration: 5000, anchorOrigin: { vertical: 'top', horizontal: 'center' } },
        Preact.h(Alert_1.default, { severity: "info", variant: "filled", sx: {
                /* For some reason the standard Alert doesn't vertically center the message text or action buttons. This makes it behave */
                '.MuiAlert-message': { display: 'flex', alignItems: 'center' },
                '.MuiAlert-action': { display: 'flex', alignItems: 'center' },
            }, action: Preact.h(Preact.Fragment, null,
                Preact.h(A_Button.Component, { color: "inherit", size: "small", onClick: function () {
                        p.undo();
                        p.close();
                    }, sx: { minWidth: 'min-content' } }, p.undoText.toUpperCase()),
                Preact.h(A_Button.Component, { color: "inherit", size: "small", onClick: p.close, sx: { minWidth: 'min-content' } },
                    Preact.h(Close_1.default, { fontSize: "small" }))), onClose: p.close },
            Preact.h(Typography_1.default, { variant: "body2" },
                " ",
                p.body))));
};
exports.Component = Component;
